/* eslint-disable react-hooks/exhaustive-deps */
import { useFormik } from "formik";
import React from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { AlertSuccess } from "../../../../components/alert";
import ModalComponent from "../../../../components/modal";
import ModalDegradadosComponent from "../../../../components/modal-degradados";
import { loadingAction } from "../../../../redux/actions";
import { EstadoContenido } from "../../../../utils/constants";
import { catchError, Fetch } from "../../../../utils/fetch";
import { validate } from "../validationSchema";
import BloquesInformacionUtil from "../components/BloquesInformacionUtil";
import {
  INFORMACION_UTIL_API,
  normalizeBloques,
  prepareApprovePayload,
  resolveApproveTargetId,
  shouldSkipDraftDeletion,
} from "../utils/informacionUtilApi";

const VerInformacionUtilX = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.loading);
  const [bloquesInformacionUtil, setBloquesInformacionUtil] = React.useState([]);
  const [showModal, setShowModal] = React.useState(false);
  const [showModalColores, setShowModalColores] = React.useState(false);
  const history = useHistory();

  React.useEffect(() => {
    if (id) {
      getInformacionUtil();
    }
  }, [id]);

  const getInformacionUtil = async () => {
    dispatch(loadingAction(true));

    try {
      const { data } = await Fetch(
        `${INFORMACION_UTIL_API}/${id}?_publicationState=preview&published_at_null=true`,
        "get"
      );
      setValues(data);
      setBloquesInformacionUtil(normalizeBloques(data));
      dispatch(loadingAction(false));
    } catch (error) {
      catchError(error);
      dispatch(loadingAction(false));
    }
  };

  const submit = async (values) => {
    dispatch(loadingAction(true));

    const idToApi = resolveApproveTargetId(id, values.idPadre);

    const payload = prepareApprovePayload(values, bloquesInformacionUtil, {
      draftId: id,
      published_at: new Date(),
    });

    if (shouldSkipDraftDeletion(id, idToApi)) {
      delete payload.id;
      delete payload.idPadre;
    }

    try {
      await Fetch(`${INFORMACION_UTIL_API}/aprobar/${idToApi}`, "put", payload);
      AlertSuccess("Seccion actualizado con éxito");
      dispatch(loadingAction(false));
      history.push("/configuracion/informacion-util/lista");
    } catch (error) {
      catchError(error);
      dispatch(loadingAction(false));
    }
  };

  const onCancelar = async () => {
    dispatch(loadingAction(true));

    try {
      const params = {
        published_at: null,
        estado: EstadoContenido.EnRevision,
      };

      await Fetch(`${INFORMACION_UTIL_API}/${id}`, "put", params);

      dispatch(loadingAction(false));
      AlertSuccess("Se ha cancelado la publicación de la sección con éxito");

      history.push("/configuracion/informacion-util/lista-borradores");
    } catch (error) {
      dispatch(loadingAction(false));
      catchError(error);
    }
  };

  const {
    values,
    errors,
    handleSubmit,
    handleChange,
    handleBlur,
    setValues,
  } = useFormik({
    initialValues: {
      nombre: "",
      descripcion: "",
      locale: "es",
    },
    enableReinitialize: true,
    validationSchema: validate,
    onSubmit: (values) => submit(values),
  });

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit}>
        <Row>
          <Col>
            <ModalDegradadosComponent
              isShow={showModal}
              setShowModal={setShowModal}
            />
            <ModalComponent
              isShow={showModalColores}
              setShowModal={setShowModalColores}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <Card.Header>Información útil</Card.Header>
              <Card.Body>
                <Row>
                  <Col>
                    <Form.Group>
                      <label>Nombre</label>
                      <input
                        type="text"
                        name="nombre"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="form-control"
                        value={values.nombre}
                      />
                      {errors && errors.nombre && (
                        <div className="text-danger">{errors.nombre}</div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group>
                      <label>Descripcion</label>
                      <input
                        type="text"
                        name="descripcion"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="form-control"
                        value={values.descripcion}
                      />
                      {errors && errors.descripcion && (
                        <div className="text-danger">{errors.descripcion}</div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>

                <BloquesInformacionUtil
                  bloques={bloquesInformacionUtil}
                  setBloques={setBloquesInformacionUtil}
                />

                <Row className="mt-5">
                  <Col className="col col-lg-2">
                    <Button
                      type="button"
                      onClick={() => handleSubmit()}
                      disabled={isLoading}
                      className="btn btn-success btn-icon"
                    >
                      <i className="fa fa-floppy-o" />
                      Publicar
                    </Button>
                  </Col>
                  <Col className="col col-lg-3">
                    <Button
                      type="button"
                      onClick={() => onCancelar()}
                      disabled={isLoading}
                      className="btn btn-primary btn-icon"
                    >
                      <i className="fa fa-undo " />
                      Por revisar
                    </Button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </form>
    </React.Fragment>
  );
};

export default VerInformacionUtilX;
